import React, { Component } from 'react';
import PropTypes from 'prop-types';
import md5 from 'md5';
import config from '../Config';
import { Button, Form, Icon, Input } from 'antd';
import 'antd/dist/antd.css';

const FormItem = Form.Item;

class KazooLoginForm extends Component {
  static propTypes = {
    loggedIn: PropTypes.func.isRequired,
    form: PropTypes.object.isRequired,
    service: PropTypes.string.isRequired
  };

  authenticate = (account_name, username, password) => {
    const pre_hash_string = `${username}:${password}`,
      hashtoken = md5(pre_hash_string);
    fetch(config[this.props.service.toUpperCase()+'_API_URL'] + 'user_auth', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        'data': {
          'credentials': hashtoken,
          'account_name': account_name
        }
      })
    }).then(resp => resp.json())
      .then(resp => {
        if (resp.auth_token && resp.auth_token !== 'undefined') {
          return this.props.loggedIn(resp.auth_token, resp.data.account_id);
        }
      });
    // TODO: Handle invalid password
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.authenticate(values.accountName, values.userName, values.password);
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Form onSubmit={this.handleSubmit} className="login-form">
        <FormItem>
          {getFieldDecorator('userName', {
            rules: [{ required: true, message: 'Please input your username!' }],
          })(
            <Input
              prefix={
                <Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />
              }
              placeholder="Username" />
          )}
        </FormItem>
        <FormItem>
          {getFieldDecorator('password', {
            rules: [{ required: true, message: 'Please input your password!' }],
          })(
            <Input prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password" placeholder="Password" />
          )}
        </FormItem>
        <FormItem>
          {getFieldDecorator('accountName', {
            rules: [{ required: true, message: 'Please input your account name!' }],
          })(
            <Input prefix={<Icon type="team" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="Account Name" />
          )}
        </FormItem>
        <FormItem>
          <Button type="primary" htmlType="submit" className="login-form-button">
            Log in
          </Button>
        </FormItem>
      </Form>
    );
  }
}

export default Form.create()(KazooLoginForm);
